import script from "./MainPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./MainPage.vue?vue&type=script&setup=true&lang=ts"

import "./MainPage.vue?vue&type=style&index=0&id=181e11d4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-181e11d4"]])

export default __exports__